// removed by extract-text-webpack-plugin
module.exports = {"fade-in":"dh-fotballvm18-fade-in","fade-in-anim":"dh-fotballvm18-fade-in-anim","fade-in--not-loaded":"dh-fotballvm18-fade-in--not-loaded"};